import { createFileRoute, redirect, useLocation } from '@tanstack/react-router';
import { NativeRedirectComplete } from '../components';
import { isNativeDeepLink, hasNativeRedirectUri } from '../services/route-utils';

export const Route = createFileRoute('/native-redirect')({
  beforeLoad: ({ location }) => {
    const redirectTo = (location.state as { redirectTo?: unknown })?.redirectTo;
    if (typeof redirectTo !== 'string' || (!isNativeDeepLink(redirectTo) && !hasNativeRedirectUri(redirectTo))) {
      throw redirect({ to: '/' });
    }
  },
  component: NativeRedirectRouteComponent,
});

function NativeRedirectRouteComponent() {
  const redirectTo = useLocation({
    select: (loc) => (loc.state as { redirectTo?: string }).redirectTo,
  });
  // beforeLoad guarantees redirectTo is a validated weave:// URL string.
  return <NativeRedirectComplete redirectTo={redirectTo as string} />;
}
